import { render, staticRenderFns } from "./ProgressSteps.vue?vue&type=template&id=4b3b878e&scoped=true&"
import script from "./ProgressSteps.vue?vue&type=script&lang=js&"
export * from "./ProgressSteps.vue?vue&type=script&lang=js&"
import style0 from "./ProgressSteps.vue?vue&type=style&index=0&id=4b3b878e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3b878e",
  null
  
)

export default component.exports